import { useDeviceInfo } from '../../../../device-provider';

export const useModalVariant = () => {
  const { device } = useDeviceInfo();
  return device === 'mobile' ? 'layer' : 'window';
};
